import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { getShares } from '../SearchContentTable.utils';
import { TextCell } from '../components/TextCell';

export const ColumnShares: ColumnHelperMethodType = (columnHelper) => {
  return columnHelper.accessor((row) => row.contentId, {
    id: 'Shares',
    cell: ({ row }) => <TextCell>{getShares(row.original)}</TextCell>,
  });
};
